import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { USER_MANAGEMENT } from "../../utils/const";
import useApi from "../../hook/useAPI";

const VerifyEmail = () => {
  const token = useLocation();
  const { getData } = useApi();

  const verify =async () => {
    await getData(`${USER_MANAGEMENT.VERIFY_EMAIL}${token?.search}`);
  }; 
 
  useEffect(() => {
    const timer = setTimeout(() => {
      verify();
    }, 3000);

    return () => clearTimeout(timer);
  }, []); 

  return (
    <>
      <h2 className="login-form-wrapper-title text-center">Email Verified</h2>
    </>
  );
};

export default VerifyEmail;
